import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _37842105 = () => interopDefault(import('../../../pages/_redirects/index.vue' /* webpackChunkName: "pages/_redirects/index" */))
const _771ee2a6 = () => interopDefault(import('../../../pages/_redirects/winter-native-app.vue' /* webpackChunkName: "pages/_redirects/winter-native-app" */))
const _09336242 = () => interopDefault(import('../../../pages/_redirects/winter-iframe.vue' /* webpackChunkName: "pages/_redirects/winter-iframe" */))
const _00ee55f7 = () => interopDefault(import('../../../pages/_redirects/winter-terminal.vue' /* webpackChunkName: "pages/_redirects/winter-terminal" */))
const _7c75a3dc = () => interopDefault(import('../../../pages/_redirects/winter-maps.vue' /* webpackChunkName: "pages/_redirects/winter-maps" */))
const _d61fa5ac = () => interopDefault(import('../../../pages/_season/maps/overview.vue' /* webpackChunkName: "pages/_season/maps/overview" */))
const _462ea9fd = () => interopDefault(import('../../../pages/_season/iframe/overview.vue' /* webpackChunkName: "pages/_season/iframe/overview" */))
const _0d06e63a = () => interopDefault(import('../../../pages/_season/native-app/_resort.vue' /* webpackChunkName: "pages/_season/native-app/_resort" */))
const _013d3e1c = () => interopDefault(import('../../../pages/_season/iframe/_resort.vue' /* webpackChunkName: "pages/_season/iframe/_resort" */))
const _04ed8634 = () => interopDefault(import('../../../pages/_season/terminal/_resort.vue' /* webpackChunkName: "pages/_season/terminal/_resort" */))
const _45d8214f = () => interopDefault(import('../../../pages/_season/maps/_resort.vue' /* webpackChunkName: "pages/_season/maps/_resort" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/maps/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/cn",
    component: _37842105,
    name: "redirects___cn"
  }, {
    path: "/en",
    component: _37842105,
    name: "redirects___en"
  }, {
    path: "/fr",
    component: _37842105,
    name: "redirects___fr"
  }, {
    path: "/cn/app/:resort",
    component: _771ee2a6,
    name: "redirects-winter-native-app___cn"
  }, {
    path: "/cn/iframe/:resort",
    component: _09336242,
    name: "redirects-winter-iframe___cn"
  }, {
    path: "/cn/terminal/:resort",
    component: _00ee55f7,
    name: "redirects-winter-terminal___cn"
  }, {
    path: "/en/app/:resort",
    component: _771ee2a6,
    name: "redirects-winter-native-app___en"
  }, {
    path: "/en/iframe/:resort",
    component: _09336242,
    name: "redirects-winter-iframe___en"
  }, {
    path: "/en/terminal/:resort",
    component: _00ee55f7,
    name: "redirects-winter-terminal___en"
  }, {
    path: "/fr/app/:resort",
    component: _771ee2a6,
    name: "redirects-winter-native-app___fr"
  }, {
    path: "/fr/iframe/:resort",
    component: _09336242,
    name: "redirects-winter-iframe___fr"
  }, {
    path: "/fr/terminal/:resort",
    component: _00ee55f7,
    name: "redirects-winter-terminal___fr"
  }, {
    path: "/app/:resort",
    component: _771ee2a6,
    name: "redirects-winter-native-app___de"
  }, {
    path: "/cn/:resort",
    component: _7c75a3dc,
    name: "redirects-winter-maps___cn"
  }, {
    path: "/en/:resort",
    component: _7c75a3dc,
    name: "redirects-winter-maps___en"
  }, {
    path: "/fr/:resort",
    component: _7c75a3dc,
    name: "redirects-winter-maps___fr"
  }, {
    path: "/iframe/:resort",
    component: _09336242,
    name: "redirects-winter-iframe___de"
  }, {
    path: "/terminal/:resort",
    component: _00ee55f7,
    name: "redirects-winter-terminal___de"
  }, {
    path: "/cn/:season/overview",
    component: _d61fa5ac,
    name: "season-maps-overview___cn"
  }, {
    path: "/en/:season/overview",
    component: _d61fa5ac,
    name: "season-maps-overview___en"
  }, {
    path: "/fr/:season/overview",
    component: _d61fa5ac,
    name: "season-maps-overview___fr"
  }, {
    path: "/cn/:season/iframe/overview",
    component: _462ea9fd,
    name: "season-iframe-overview___cn"
  }, {
    path: "/en/:season/iframe/overview",
    component: _462ea9fd,
    name: "season-iframe-overview___en"
  }, {
    path: "/fr/:season/iframe/overview",
    component: _462ea9fd,
    name: "season-iframe-overview___fr"
  }, {
    path: "/cn/:season/app/:resort",
    component: _0d06e63a,
    name: "season-native-app-resort___cn"
  }, {
    path: "/cn/:season/iframe/:resort",
    component: _013d3e1c,
    name: "season-iframe-resort___cn"
  }, {
    path: "/cn/:season/terminal/:resort",
    component: _04ed8634,
    name: "season-terminal-resort___cn"
  }, {
    path: "/en/:season/app/:resort",
    component: _0d06e63a,
    name: "season-native-app-resort___en"
  }, {
    path: "/en/:season/iframe/:resort",
    component: _013d3e1c,
    name: "season-iframe-resort___en"
  }, {
    path: "/en/:season/terminal/:resort",
    component: _04ed8634,
    name: "season-terminal-resort___en"
  }, {
    path: "/fr/:season/app/:resort",
    component: _0d06e63a,
    name: "season-native-app-resort___fr"
  }, {
    path: "/fr/:season/iframe/:resort",
    component: _013d3e1c,
    name: "season-iframe-resort___fr"
  }, {
    path: "/fr/:season/terminal/:resort",
    component: _04ed8634,
    name: "season-terminal-resort___fr"
  }, {
    path: "/cn/:season/:resort",
    component: _45d8214f,
    name: "season-maps-resort___cn"
  }, {
    path: "/en/:season/:resort",
    component: _45d8214f,
    name: "season-maps-resort___en"
  }, {
    path: "/fr/:season/:resort",
    component: _45d8214f,
    name: "season-maps-resort___fr"
  }, {
    path: "/",
    component: _37842105,
    name: "redirects___de"
  }, {
    path: "/:resort",
    component: _7c75a3dc,
    name: "redirects-winter-maps___de"
  }, {
    path: "/:season/overview",
    component: _d61fa5ac,
    name: "season-maps-overview___de"
  }, {
    path: "/:season/iframe/overview",
    component: _462ea9fd,
    name: "season-iframe-overview___de"
  }, {
    path: "/:season/app/:resort",
    component: _0d06e63a,
    name: "season-native-app-resort___de"
  }, {
    path: "/:season/iframe/:resort",
    component: _013d3e1c,
    name: "season-iframe-resort___de"
  }, {
    path: "/:season/terminal/:resort",
    component: _04ed8634,
    name: "season-terminal-resort___de"
  }, {
    path: "/:season/:resort",
    component: _45d8214f,
    name: "season-maps-resort___de"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
